import { useSidebar } from "ui/components/sidebar";
import { Icon } from "components";
import { REPORTS } from "icons";

export function CollapsibleReportHeader({ className = "" }) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  return (
    <div className="flex flex-col gap-2" {...className}>
      <div className="flex items-center gap-2">
        {isCollapsed && <Icon icon={REPORTS} size={16} />}
        {!isCollapsed && <h2 className="font-semibold text-lg transition-all duration-200">Reports</h2>}
      </div>
    </div>
  );
}